import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AdvertiserForAddEngagement.graphql';
import { Query } from '../../__generated__/globalTypes';

export const useAdvertiserForAddEngagementQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAdvertiserForAddEngagementLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & { getAdvertiserForAddEngagementQuery: LazyQueryExecFunction<Query, OperationVariables> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getAdvertiserForAddEngagement
  const [getAdvertiserForAddEngagementQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAdvertiserForAddEngagementQuery, ...result };
};

export const useAdvertiserForAddEngagementPromiseQuery = () => {
  const client = useApolloClient();

  const getAdvertiserForAddEngagement = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getAdvertiserForAddEngagement };
};
